import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { NAV_LINKS } from "../../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-ivory">
      <div className="yadid-container py-9">
        {/* Top row: brand ethos + advisor access */}
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:items-center md:justify-between md:gap-8 md:text-left">
          <p className="eyebrow text-brass text-[0.62rem]">
            See clearly. Connect wisely. Move confidently.
          </p>

          <a
            href="https://app.yadidadvisory.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="yadidos-link"
            className="group inline-flex items-center gap-3 border border-white/15 hover:border-brass/60 py-2.5 pl-3 pr-6 transition-colors duration-500"
          >
            <img src="/yadidos-icon-white.png" alt="YadidOS" className="h-9 w-9 object-contain shrink-0" />
            <span className="flex flex-col text-left">
              <span className="flex items-center gap-2 font-poppins font-medium text-base text-ivory leading-none tracking-tight">
                YadidOS
                <ExternalLink
                  size={13}
                  className="text-brass opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all duration-400"
                />
              </span>
              <span className="eyebrow text-brass/70 text-[0.55rem] mt-1">Advisor Access</span>
            </span>
          </a>
        </div>

        {/* Divider */}
        <div className="my-7 border-t border-white/10" />

        {/* Bottom row: navigation + legal */}
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:items-center md:justify-between md:gap-8 md:text-left">
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 md:justify-start">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.to.replace("/", "")}`}
                className="whitespace-nowrap text-sm text-ivory/70 hover:text-ivory transition-colors duration-400"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex flex-col items-center gap-2 sm:flex-row sm:gap-6">
            <p className="whitespace-nowrap text-ivory/40 text-xs tracking-wide">
              © {new Date().getFullYear()} Yadid Advisory LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-ivory/40 hover:text-ivory/70 text-xs transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-ivory/40 hover:text-ivory/70 text-xs transition-colors">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
